import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { baseModuleScreens } from '../../constants';
import BaseModuleOverview from '../../components/BaseModule/BaseModuleOverview';
import BaseModuleUpdate from '../../components/BaseModule/BaseModuleUpdate';
import BaseModuleCreate from '../../components/BaseModule/BaseModuleCreate';
import { getFieldTypes, getLangs, getBaseModuleList } from '../../actions/baseModule';
import { loadMedia } from '../../actions/media';
import BaseModuleItemsOverview from './BaseModuleItems/BaseModuleItemsOverview';
import BaseModuleItems from './BaseModuleItems/BaseModuleItems';
import BaseModuleItemCreate from './BaseModuleItems/BaseModuleItemEdit/BaseModuleItemCreate';
import BaseModuleItemEdit from './BaseModuleItems/BaseModuleItemEdit/BaseModuleItemEdit';
import { getNsiProductTypes, getNsiDetailFilters } from '../../actions/baseModuleItems';
import Spinner from '../Spinner';
import { baseModuleFetchData, baseModuleItemsFetchData } from '../../selectors';
import LanguageContext from '../Languages/LanguageContext';

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  getBaseModuleList: PropTypes.func.isRequired,
  currentScreen: PropTypes.string.isRequired,
  domain: PropTypes.string,
  loadMedia: PropTypes.func.isRequired,
  getFieldTypes: PropTypes.func.isRequired,
  getLangs: PropTypes.func.isRequired,
  getNsiProductTypes: PropTypes.func.isRequired,
  getNsiDetailFilters: PropTypes.func.isRequired,
  baseModuleFetch: PropTypes.bool,
  baseModuleLang: PropTypes.string.isRequired,
};

const defaultProps = {
  baseModuleFetchData: false,
  baseModuleItemsFetchData: false,
  domain: null,
};

const getCurrentScreen = (currentScreen) => {
  switch (currentScreen) {
    case 'overview':
      return <BaseModuleOverview />;
    case 'create':
      return <BaseModuleCreate />;
    case 'edit':
      return <BaseModuleUpdate />;
    case 'items':
      return <BaseModuleItemsOverview />;
    case baseModuleScreens.moduleItemsList:
      return <BaseModuleItems />;
    case baseModuleScreens.createModuleItem:
      return <BaseModuleItemCreate />;
    case baseModuleScreens.editModuleItem:
      return <BaseModuleItemEdit />;
    default:
      return null;
  }
};

class BaseModuleContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: false,
    };
  }

  componentDidMount() {
    this.props.loadMedia();
    this.props.getFieldTypes();
    this.props.getLangs();
    this.props.getBaseModuleList();
  }

  componentDidUpdate(prevProps) {
    const { domain } = this.props;

    if (domain && domain !== prevProps.domain && domain === 'nsi-be.com') {
      this.props.getNsiProductTypes();
      this.props.getNsiDetailFilters();
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = '';
  }

  render() {
    const { isOpen, currentScreen, baseModuleFetch, baseModuleLang } = this.props;

    if (!isOpen) {
      document.body.style.overflow = '';
      return null;
    }

    // remove scroll when base module open
    document.body.style.overflow = 'hidden';

    if (baseModuleFetch) {
      return (
        <div className="c-bb-basemodule">
          <Spinner size={4} />
        </div>
      );
    }

    return (
      <LanguageContext.Provider value={{ lang: baseModuleLang }} >
        {getCurrentScreen(currentScreen)}
      </LanguageContext.Provider>
    );
  }
}

BaseModuleContainer.propTypes = propTypes;
BaseModuleContainer.defaultProps = defaultProps;

const mapStateToProps = state => ({
  isOpen: state.baseModule.isOpen,
  currentScreen: state.baseModule.currentScreen,
  baseModuleFetch: baseModuleFetchData(state),
  baseModuleItemsFetch: baseModuleItemsFetchData(state),
  baseModulesList: state.baseModule.modulesList,
  domain: state.global.websiteSettings.domain,
  baseModuleLang: state.baseModule.lang,
});

const mapDispatchToProps = {
  loadMedia,
  getFieldTypes,
  getLangs,
  getBaseModuleList,
  getNsiProductTypes,
  getNsiDetailFilters,
};

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(BaseModuleContainer));



// WEBPACK FOOTER //
// ./src/components/BaseModule/BaseModuleContainer.js